import styled from '@emotion/styled';

import DetailViewSubSection from './DetailViewSubSection';

import type { DetailViewSubSectionContainerProps } from './types';

/**
 * [ DetailViewSection의 children로 주입 가능한 서브 섹션을 랜더링하는 컴포넌트 ]
 *
 * - DetailView의 props.sections로 내려주는 section을 sub section으로 랜더링하기 위해 사용하는 컴포넌트입니다.
 * - type SectionItem의 content로 DetailViewSubSectionContainer를 넘겨주면 subSection으로 랜더링합니다.
 *
 * @example
 * const sections = [
 *   {
 *     header: '세부정보',
 *     content: <DetailViewSubSectionContainer subSections={[]} />
 *   },
 *   ...
 * ]
 *
 * return <DetailView sections={sections} />
 */
const DetailViewSubSectionContainer = ({
  subSections,
  depth = 2,
}: DetailViewSubSectionContainerProps) => {
  return (
    <StyledWrapper depth={depth}>
      {subSections.map(({ header, content, headerAction, description }, index) => {
        return (
          <DetailViewSubSection
            key={index}
            description={description}
            content={content}
            header={header}
            headerAction={headerAction}
            depth={depth}
          />
        );
      })}
    </StyledWrapper>
  );
};

const StyledWrapper = styled('div', {
  shouldForwardProp: prop => prop !== 'depth',
})<{ depth: number }>`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  max-width: 100%;
  margin-left: ${({ depth }) => (depth === 3 ? '16px' : '0px')};
  gap: ${({ depth }) => (depth === 3 ? '20px' : '24px')};
`;

export default DetailViewSubSectionContainer;
